import * as React from "react";
import {Video} from "@models/video-content";
import { Rate , Table} from "antd";
import {FormattedMessage, intlShape} from "react-intl";
import './index.scss'
import {getFormattedPrice} from '@utils';
import FormattedDateTime from '@components/custom/FormattedDateTime';
import {getFormattedDate} from "../../../utils";


type Props = {
  data: Video[];
  loading: boolean;
  deleteFn: (item: Video) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ReportList: React.FC<Props> = props => {
  const {data, loading} = props;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      render: (a, b, i) => <span>{i + 1 }</span>
    },
    {
      title: <FormattedMessage id="app.sum_price" defaultMessage={`Sum Price`}/>,
      dataIndex: "sum_price",
      key: "sum_price",
      align:"right",
      render:(sum_price) => getFormattedPrice(sum_price)
    },
    {
      title: <FormattedMessage id="app.sum_effective_price" defaultMessage={`Sum Effective Price`}/>,
      dataIndex: "sum_effective_price",
      key: "sum_effective_price",
      align:"center",
      render:(sum_effective_price) => getFormattedPrice(sum_effective_price)
    },
    {
      title: <FormattedMessage id="app.total_count" defaultMessage={`Total Count`}/>,
      dataIndex: "total",
      key: "total",
      align:"center",
    },
    {
      title: <FormattedMessage id="app.date" defaultMessage={`Date`}/>,
      dataIndex: 'date_time',
      key: 'date_time',
      align:"left",
      render: (date_time) => getFormattedDate({date: date_time, showTime: false})
    },
  ];
  
  return (
    <Table
      className={'report-table'}
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default ReportList;
